import { clsx } from 'clsx'
import { type CSSProperties, type PropsWithChildren } from 'react'
import { richTextContainer } from './RichText.css'

type RichTextProps = PropsWithChildren<{ largeText?: boolean; className?: string; style?: CSSProperties }>

export const RichText = ({ largeText, className, ...rest }: RichTextProps) => {
  return <div data-large-text={largeText} className={clsx(className, richTextContainer)} {...rest} />
}
